import { Component, Input, ViewChild } from '@angular/core'
import { Validators } from '@angular/forms'
import {
  E11DynamicFormBuilderComponent,
  E11DynamicFormModule,
  e11FieldInputText,
  e11FormFor,
  E11FormForType,
  e11FormLayoutFullWidth,
} from '@engineering11/ui-lib/e11-form-builder'
import { TranslateModule } from '@ngx-translate/core'
import { IAutoQuestionFormComponent, IAutoQuestionFormData } from '../../auto-questions.model'

export type AutomatedQuestionNameForm = Pick<IAutoQuestionFormData, 'name'>
const MAX_NAME_LENGTH = 50

@Component({
  selector: 'automated-question-name-form',
  standalone: true,
  imports: [E11DynamicFormModule, TranslateModule],
  template: `
    @if (nameFormFieldGroup) {
    <e11-dynamic-form-builder [hideSubmitMenu]="true" #nameForm [fieldGroups]="nameFormFieldGroup"> </e11-dynamic-form-builder>
    }
  `,
})
export class AutomatedQuestionNameFormComponent implements IAutoQuestionFormComponent {
  @ViewChild('nameForm') nameForm!: E11DynamicFormBuilderComponent<AutomatedQuestionNameForm>
  @Input() set formData(formData: IAutoQuestionFormData | undefined) {
    this.nameFormFieldGroup = this.buildForm(formData)
  }

  nameFormFieldGroup: E11FormForType<AutomatedQuestionNameForm> | undefined = undefined

  private buildForm(formData: IAutoQuestionFormData | undefined): E11FormForType<AutomatedQuestionNameForm> {
    return e11FormFor<AutomatedQuestionNameForm>()([
      e11FormLayoutFullWidth(
        [
          e11FieldInputText('name', 'Question set name', formData?.name, {
            extraInputOption: {
              maxLength: MAX_NAME_LENGTH,
            },
            validatorOrOpts: [Validators.required, Validators.maxLength(MAX_NAME_LENGTH)],
          }),
        ],
        {
          templateSpec: { templatePosition: 'top', templateKey: 'nameHeader' },
        }
      ),
    ])
  }

  validateAndReturnData(): AutomatedQuestionNameForm | undefined {
    this.nameForm.onSubmitClick()
    if (this.nameForm.form.invalid) {
      return undefined
    }
    return this.nameForm.form.value
  }
}
